import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {Company} from 'main/stores/company';

class PlatformCustomizationState {
  store = new DomainStore();

  company;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([endpoints.CURRENT_COMPANY]);

    this.company = new Company(this.store._getSingle(types.COMPANY));
  }

  updatePlatformColor(color) {
    this.company.platformColor = color;
  }

  async saveColor() {
    const {model} = await this.store.patch(
      endpoints.COMPANY.with(this.company.id),
      types.COMPANY,
      this.company
    );

    if (model) {
      location.reload();
    }
  }
}

export default PlatformCustomizationState;
